import React from "react"
import { api_freedom } from "../services/apis"
import jwt_decode from 'jwt-decode'
import jwt from 'jsonwebtoken'
import moment from "moment"

const ExemplePayload = {
    contratos: {
        "1797158": {
            "id": 25550,
            "document_number": "1797158",
            "contrato_id": 2629
        },
        "1797386": {
            "id": 25591,
            "document_number": "1797386",
            "contrato_id": 1676
        },
    },
    data_inicio: '2022-06-08',
    data_fim: '2022-06-08',
    extrato: [
        {
            "InternalIdentifier": 0,
            "EntryId": 0,
            "Description": "Saldo Inicial",
            "Subtype": 21,
            "EntryDate": "2022-06-01T00:00:00",
            "EntryValue": 54281.56,
            "Type": "InitialBalance",
            "UsedGuaranteed": null,
            "GuaranteedValue": null,
            "Details": "Saldo Inicial",
            "ReceiptUrl": "https://receipt.fitbank.com.br/receiptapi/pdf?filename=2022-06-08/caeuw4k1.pdf",
            "BankDetails": null,
            "DocumentNumber": null,
            "TransactionId": null,
            "Bank": null,
            "BankBranch": null,
            "BankAccount": null,
            "BankAccountDigit": null,
            "OperationId": null,
            "NoteId": null,
            "NoteEntry": null,
            "OperationType": 0,
            "ManualEntryCategory": 0,
            "ReceiptFileName": null,
            "Tags": []
        },
        {
            "InternalIdentifier": 1745347794,
            "EntryId": 1745347794,
            "Description": "Compra com boleto",
            "Subtype": 2,
            "EntryDate": "2022-06-01T07:13:50.493",
            "EntryValue": 1649.12,
            "Type": "PurchaseWithBoleto",
            "UsedGuaranteed": null,
            "GuaranteedValue": null,
            "Details": "Boleto Pago Uiara Freitas Xavier",
            "ReceiptUrl": null,
            "BankDetails": null,
            "DocumentNumber": "1797158",
            "TransactionId": 1797158,
            "Bank": null,
            "BankBranch": null,
            "BankAccount": null,
            "BankAccountDigit": null,
            "OperationId": 117665230,
            "NoteId": 104906618,
            "NoteEntry": 1745347801,
            "OperationType": 0,
            "ManualEntryCategory": 0,
            "ReceiptFileName": null,
            "Tags": [
                "2629"
            ]
        },
        {
            "InternalIdentifier": 1745347795,
            "EntryId": 1745347795,
            "Description": "Multa Boleto",
            "Subtype": 25,
            "EntryDate": "2022-06-01T07:13:50.51",
            "EntryValue": 165.45,
            "Type": "FineValue",
            "UsedGuaranteed": null,
            "GuaranteedValue": null,
            "Details": "Multa",
            "ReceiptUrl": null,
            "BankDetails": null,
            "DocumentNumber": "1797158",
            "TransactionId": 1797158,
            "Bank": null,
            "BankBranch": null,
            "BankAccount": null,
            "BankAccountDigit": null,
            "OperationId": 117665230,
            "NoteId": 104906618,
            "NoteEntry": 1745347801,
            "OperationType": 0,
            "ManualEntryCategory": 0,
            "ReceiptFileName": null,
            "Tags": [
                "2629"
            ]
        },
        {
            "InternalIdentifier": 1745347796,
            "EntryId": 1745347796,
            "Description": "Taxa de recebimento de boleto",
            "Subtype": 4,
            "EntryDate": "2022-06-01T07:13:50.523",
            "EntryValue": -2.9,
            "Type": "RateByBoleto",
            "UsedGuaranteed": false,
            "GuaranteedValue": null,
            "Details": "Taxa de emissão de boleto",
            "ReceiptUrl": null,
            "BankDetails": null,
            "DocumentNumber": "1797158",
            "TransactionId": 1797158,
            "Bank": null,
            "BankBranch": null,
            "BankAccount": null,
            "BankAccountDigit": null,
            "OperationId": 117665230,
            "NoteId": 104906618,
            "NoteEntry": 1745347801,
            "OperationType": 0,
            "ManualEntryCategory": 0,
            "ReceiptFileName": null,
            "Tags": [
                "2629"
            ]
        },
        {
            "InternalIdentifier": 1745347820,
            "EntryId": 1745347820,
            "Description": "Compra com boleto",
            "Subtype": 2,
            "EntryDate": "2022-06-01T07:13:51.47",
            "EntryValue": 1802.38,
            "Type": "PurchaseWithBoleto",
            "UsedGuaranteed": null,
            "GuaranteedValue": null,
            "Details": "Boleto Pago FLAVIA LEITE LIMA",
            "ReceiptUrl": null,
            "BankDetails": null,
            "DocumentNumber": "1797386",
            "TransactionId": 1797386,
            "Bank": null,
            "BankBranch": null,
            "BankAccount": null,
            "BankAccountDigit": null,
            "OperationId": 117718682,
            "NoteId": 104959479,
            "NoteEntry": 1745347827,
            "OperationType": 0,
            "ManualEntryCategory": 0,
            "ReceiptFileName": null,
            "Tags": [
                "1676"
            ]
        }
    ]
    // extrato: [
    //     {
    //         EntryDate: '2022-06-08',
    //         Details: 'Teste',
    //         EntryValue: 1000.00,
    //         DocumentNumber: 1,
    //         ReceiptUrl: 'www.url.com.br',
    //         Tags: [1234, 5678],
    //     },
    //     {
    //         EntryDate: '2022-06-08',
    //         Details: 'Teste',
    //         EntryValue: 1000.00,
    //         DocumentNumber: 1,
    //         ReceiptUrl: 'www.url.com.br',
    //         Tags: [1234, 5678],
    //     },
    //     {
    //         EntryDate: '2022-06-08',
    //         Details: 'Teste',
    //         EntryValue: 1000.00,
    //         DocumentNumber: 1,
    //         ReceiptUrl: 'www.url.com.br',
    //         Tags: [1234, 5678],
    //     },
    //     {
    //         EntryDate: '2022-06-08',
    //         Details: 'Teste',
    //         EntryValue: 1000.00,
    //         DocumentNumber: 1,
    //         ReceiptUrl: 'www.url.com.br',
    //         Tags: [1234, 5678],
    //     },
    //     {
    //         EntryDate: '2022-06-08',
    //         Details: 'Teste',
    //         EntryValue: 1000.00,
    //         DocumentNumber: 1,
    //         ReceiptUrl: 'www.url.com.br',
    //         Tags: [1234, 5678],
    //     },
    //     {
    //         EntryDate: '2022-06-08',
    //         Details: 'Teste',
    //         EntryValue: 1000.00,
    //         DocumentNumber: 1,
    //         ReceiptUrl: 'www.url.com.br',
    //         Tags: [1234, 5678],
    //     },
    // ]
}

class ExtratoImobPage extends React.Component {
    constructor(props) {
        super(props)

        console.log(JSON.parse("[{\"InternalIdentifier\":0,\"EntryId\":0,\"Description\":\"Saldo Inicial\",\"Subtype\":21,\"EntryDate\":\"2022-06-01T00:00:00\",\"EntryValue\":54281.56,\"Type\":\"InitialBalance\",\"UsedGuaranteed\":null,\"GuaranteedValue\":null,\"Details\":\"Saldo Inicial\",\"ReceiptUrl\":null,\"BankDetails\":null,\"DocumentNumber\":null,\"TransactionId\":null,\"Bank\":null,\"BankBranch\":null,\"BankAccount\":null,\"BankAccountDigit\":null,\"OperationId\":null,\"NoteId\":null,\"NoteEntry\":null,\"OperationType\":0,\"ManualEntryCategory\":0,\"ReceiptFileName\":null,\"Tags\":[]},{\"InternalIdentifier\":1745347794,\"EntryId\":1745347794,\"Description\":\"Compra com boleto\",\"Subtype\":2,\"EntryDate\":\"2022-06-01T07:13:50.493\",\"EntryValue\":1649.12,\"Type\":\"PurchaseWithBoleto\",\"UsedGuaranteed\":null,\"GuaranteedValue\":null,\"Details\":\"Boleto Pago Uiara Freitas Xavier\",\"ReceiptUrl\":null,\"BankDetails\":null,\"DocumentNumber\":\"1797158\",\"TransactionId\":1797158,\"Bank\":null,\"BankBranch\":null,\"BankAccount\":null,\"BankAccountDigit\":null,\"OperationId\":117665230,\"NoteId\":104906618,\"NoteEntry\":1745347801,\"OperationType\":0,\"ManualEntryCategory\":0,\"ReceiptFileName\":null,\"Tags\":[\"2629\"]},{\"InternalIdentifier\":1745347795,\"EntryId\":1745347795,\"Description\":\"Multa Boleto\",\"Subtype\":25,\"EntryDate\":\"2022-06-01T07:13:50.51\",\"EntryValue\":165.45,\"Type\":\"FineValue\",\"UsedGuaranteed\":null,\"GuaranteedValue\":null,\"Details\":\"Multa\",\"ReceiptUrl\":null,\"BankDetails\":null,\"DocumentNumber\":\"1797158\",\"TransactionId\":1797158,\"Bank\":null,\"BankBranch\":null,\"BankAccount\":null,\"BankAccountDigit\":null,\"OperationId\":117665230,\"NoteId\":104906618,\"NoteEntry\":1745347801,\"OperationType\":0,\"ManualEntryCategory\":0,\"ReceiptFileName\":null,\"Tags\":[\"2629\"]},{\"InternalIdentifier\":1745347796,\"EntryId\":1745347796,\"Description\":\"Taxa de recebimento de boleto\",\"Subtype\":4,\"EntryDate\":\"2022-06-01T07:13:50.523\",\"EntryValue\":-2.90,\"Type\":\"RateByBoleto\",\"UsedGuaranteed\":false,\"GuaranteedValue\":null,\"Details\":\"Taxa de emissão de boleto\",\"ReceiptUrl\":null,\"BankDetails\":null,\"DocumentNumber\":\"1797158\",\"TransactionId\":1797158,\"Bank\":null,\"BankBranch\":null,\"BankAccount\":null,\"BankAccountDigit\":null,\"OperationId\":117665230,\"NoteId\":104906618,\"NoteEntry\":1745347801,\"OperationType\":0,\"ManualEntryCategory\":0,\"ReceiptFileName\":null,\"Tags\":[\"2629\"]},{\"InternalIdentifier\":1745347820,\"EntryId\":1745347820,\"Description\":\"Compra com boleto\",\"Subtype\":2,\"EntryDate\":\"2022-06-01T07:13:51.47\",\"EntryValue\":1802.38,\"Type\":\"PurchaseWithBoleto\",\"UsedGuaranteed\":null,\"GuaranteedValue\":null,\"Details\":\"Boleto Pago FLAVIA LEITE LIMA\",\"ReceiptUrl\":null,\"BankDetails\":null,\"DocumentNumber\":\"1797386\",\"TransactionId\":1797386,\"Bank\":null,\"BankBranch\":null,\"BankAccount\":null,\"BankAccountDigit\":null,\"OperationId\":117718682,\"NoteId\":104959479,\"NoteEntry\":1745347827,\"OperationType\":0,\"ManualEntryCategory\":0,\"ReceiptFileName\":null,\"Tags\":[\"1676\"]}]"));

        if (!localStorage.getItem('autenticado_freedom')) {
            props.history.push('/')
        }

        this.state = {
            dataInicio: '',
            dataFim: '',
            dados_login: jwt_decode(localStorage.getItem('autenticado_freedom')),
            extrato: [],
            contratos: [],
            balanco: 0,

            pageAtual: 1,
            quantidade_paginas: 1,
            inPrint: false
        }

        if (jwt_decode(localStorage.getItem('autenticado_freedom')).permissao_tipo !== "ReadWriteMaster") {
            this.props.history.push('/freedom/contratos')
        }
    }

    salvarObservacao = async (entryId, observacao) => {
        try {
            await api_freedom.post('/extrato/salvar-observacao', {
                entryId,
                obs: observacao
            }, {
                headers: { "authorization": localStorage.getItem('autenticado_freedom') }
            });
            alert('Observação salva com sucesso');
        } catch (error) {
            console.error('Erro ao salvar observação:', error);
            alert('Erro ao salvar observação');
        }
    }

    getStatement = async () => {
        let re

        document.querySelector('.loader__back').classList.add("active")

        try {
            re = await api_freedom.post("/extrato/buscarestrato/", {
                id: this.state.dados_login.imobiliaria_id,
                dataInicio: this.state.dataInicio,
                dataFim: this.state.dataFim,
            }, { headers: { "authorization": localStorage.getItem('autenticado_freedom') } })
        } catch (error) {
            document.querySelector('.loader__back').classList.remove("active")
            return alert("Preencha todos os campos")
        }

        if (re.data.data.toString().indexOf('TOKEN') === -1) {
            if (re.data.data.Success == "true") {
                let entradas = JSON.parse(re.data.data.Entry)

                this.setState({
                    extrato: entradas,
                    contratos: re.data.contratos,
                    quantidade_paginas: Math.ceil(entradas.length / 30),
                    obs:  re.data.obs,
                    balanco: re.data.data.Balance,
                })
            }
        }
        document.querySelector('.loader__back').classList.remove("active")
    }

    fotprint = () => {
        this.setState({ inPrint: true })

        setTimeout(() => {
            window.print()

            this.setState({ inPrint: false })
        }, 350);

    }

    genCSV = () => {
        let csv = '"Data","Descrição","Valor","Número do documento","Contrato","Link PDF"\n';

        for (const i of this.state.extrato) {
            csv += `"${moment(i.EntryDate).format("DD/MM/YYYY HH:MM")}","${i.Details}","${i.EntryValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}","${i.DocumentNumber}","${this.state.contratos[i.DocumentNumber] ? this.state.contratos[i.DocumentNumber].contrato_id : ''}","${i.ReceiptUrl ? i.ReceiptUrl : ''}",\n`
        }

        csv = csv.slice(0, csv.length - 1)

        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'extrato.csv';
        hiddenElement.click();
    }
    render() {
        return (
            <>
                <div className="loader__back">
                    <div className="loader__rolling">
                        <div className="loader"></div>
                    </div>
                </div>

                <div>
                    <div>
                        <div>
                            <p className="relatorio-title">Extrato da imobiliária</p>
                        </div>
                        <br />
                        <div className="row">
                            <div className='col-md-3 grupo__campo d-flex align-items-center'>
                                <label className="pr-0">Data Início: </label><br />
                                <div className='grupo__campo__form grupo__campo--input--select'>
                                    <input type='date' onChange={(event) => {
                                        this.setState({ dataInicio: event.target.value })
                                    }} />
                                </div>
                            </div>
                            <div className='col-md-3 grupo__campo d-flex align-items-center'>
                                <label className="pr-0">Data Fim: </label><br />
                                <div className='grupo__campo__form grupo__campo--input--select'>
                                    <input type='date' onChange={(event) => {
                                        this.setState({ dataFim: event.target.value, pag: 1 })
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className='col-md-3 grupo__campo d-flex align-items-center'>
                                <button className='ml-2 btn__primary button' onClick={this.getStatement}>Ver extrato</button>
                            </div>
                        </div>
                    </div>

                    <p>Saldo inicial: <strong>{(this.state.extrato.length > 0 ? this.state.extrato[0].EntryValue : 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></p>
                    <p>Saldo final: <strong>{(this.state.extrato.length > 0 ? this.state.extrato[this.state.extrato.length - 1].EntryValue : 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></p>
                    <p>Balanço: <strong>{this.state.balanco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></p>

                    {
                        this.inPrint ? (null) : (
                            <>
                                <button class="button btn__primary" onClick={() => {
                                    if (this.state.dataInicio && this.state.dataFim) {
                                        var linkDemonstrativo = jwt.sign({
                                            imobiliaria_id: this.state.dados_login.imobiliaria_id,
                                            data_inicio: this.state.dataInicio,
                                            data_fim: this.state.dataFim,
                                        }, 'EXTRATOIMOB')
                                        window.open(`/freedom/relatorioextratoimob/${linkDemonstrativo}`, '_blank');
                                    } else {
                                        alert('Preencha as datas para gerar o relatório')
                                    }
                                }}
                                // disabled={this.state.dataInicio && this.state.dataFim ? false : true}
                                >
                                    Imprimir relatório
                                </button>
                                <button class="button btn__primary" onClick={this.genCSV}>
                                    Gerar CSV
                                </button>
                            </>
                        )
                    }

                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="thead__item">
                                            <label>Data</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Descrição</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Valor</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Número do documento</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label># Contrato</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Link PDF</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Tag</label>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="thead__item">
                                            <label>Obs.:</label>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    (!this.inPrint ? this.state.extrato.slice(30 * (this.state.pageAtual - 1), 30 * (this.state.pageAtual - 1) + 30) : this.state.extrato).map(e => (
                                        <tr>
                                            <td>{moment(e.EntryDate).format("DD/MM/YYYY HH:MM")}</td>
                                            <td>{e.Details}</td>
                                            <td>{e.EntryValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                            <td>{e.DocumentNumber}</td>
                                            <td>{this.state.contratos[e.DocumentNumber] ? this.state.contratos[e.DocumentNumber].contrato_id : ''}</td>
                                            <td>
                                                {
                                                    e.ReceiptUrl ? (
                                                        <a href={e.ReceiptUrl} target="_blank">
                                                            <i className="fas fa-link"></i>
                                                        </a>
                                                    ) : (null)
                                                }
                                            </td>
                                            <td>{e.Tags.length > 0 ? e.Tags[0] : '---'}</td>
                                            <td>
                                                {
                                                    e.InternalIdentifier && e.InternalIdentifier !== 0 ? (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <input
                                                                type="text"
                                                                value={
                                                                    this.state.obs &&
                                                                    this.state.obs[e.EntryId] &&
                                                                    e.InternalIdentifier === e.EntryId
                                                                        ? this.state.obs[e.EntryId]
                                                                        : ''
                                                                }
                                                                onChange={event => {
                                                                    const newObs = event.target.value;
                                                                    this.setState(prevState => {
                                                                        const obs = {
                                                                            ...prevState.obs,
                                                                            [e.EntryId]: newObs
                                                                        };
                                                                        return { obs };
                                                                    });
                                                                }}
                                                                style={{ width: '100%' }}
                                                            />
                                                            <button
                                                                className="btn btn-sm btn__primary ml-2"
                                                                onClick={() => this.salvarObservacao(e.InternalIdentifier, this.state.obs && this.state.obs[e.EntryId] ? this.state.obs[e.EntryId] : '')}
                                                                type="button"
                                                            >
                                                                Salvar
                                                            </button>
                                                        </div>
                                                    ) : null
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='pagination'>
                        <div className="pagination__arrow" onClick={() => {
                            this.setState({ pageAtual: this.state.pageAtual > 1 ? this.state.pageAtual - 1 : 1 })
                        }}>
                            {'<'}
                        </div>
                        <div className="pagination__numbers">
                            {
                                [...Array(this.state.quantidade_paginas)].map((pagina, index) => {
                                    if ((this.state.pageAtual === 1 && index + 1 < 4) ||
                                        (this.state.pageAtual === this.state.quantidade_paginas && index + 1 > this.state.quantidade_paginas - 3) ||
                                        (index + 1 === this.state.pageAtual - 1 || index + 1 === this.state.pageAtual || index + 1 === this.state.pageAtual + 1)
                                    ) {
                                        return (
                                            <p className={this.state.pagina === index + 1 ? 'pagination__index' : ''} onClick={() => {
                                                this.setState({ pageAtual: index + 1 })
                                            }}>
                                                {index + 1}
                                            </p>
                                        )
                                    }
                                    else {
                                        return null
                                    }
                                })
                            }
                        </div>
                        <div className="pagination__arrow" onClick={() => {
                            this.setState({ pageAtual: this.state.pageAtual < this.state.quantidade_paginas ? this.state.pageAtual + 1 : this.state.quantidade_paginas })
                        }}>
                            {'>'}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ExtratoImobPage